<template>
	<div class="menu-module-header">
		<div class="menu-module-title">{{ composeModuleTitle(item) }}</div>
		<div
			v-if="
				item.moduleId === 'north_south_funds' ||
				item.moduleId === 'margin_funds' ||
				item.moduleId === 'dividend_plan' ||
				item.moduleId === 'fund_holding'
			"
			class="menu-module-right"
		>
			<span class="unit-font">{{ getCurrUnitTips }}</span>
		</div>
		<div v-if="item.moduleId === 'shareholder'" class="more-shareholder">
			<div class="menu-module-right">{{ shareholdersWords }}</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from '@/utils/vue-api';
import i18n from '@/assets/js/i18n';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	}
});

const composeModuleTitle = ({ name }) => name;

const store = useStore();
const getCurrUnitTips = computed(() => store.getters.getCurrUnitTips);
const shareholdersWords = computed(
	() => `${i18n.t('enterprise.number-of-shareholders')}（${i18n.t('enterprise.thousand-households')}）`
);
</script>

<style lang="less" scoped>
.menu-module-header {
	margin-top: 0.14rem;
	margin-bottom: 0.16rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.menu-module-title {
	color: #333;
	font-family: 'PingFang SC';
	font-size: 0.16rem;
	font-style: normal;
	font-weight: 500;
	line-height: 140%;
	word-break: break-word;
}
.more-shareholder {
	margin-left: 0.06rem;
	text-align: right;

	.menu-module-right {
		&::before {
			content: '';
			margin-right: 0.06rem;
			display: inline-block;
			width: 0.1rem;
			height: 0.1rem;
			border-radius: 0.02rem;
			background: var(--ir-theme-color);
			flex: none;
		}
	}
}
.menu-module-right {
	color: #666;
	font-family: 'PingFang SC';
	font-size: 0.12rem;
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
	text-align: right;
}
.unit-font {
	font-family: Barlow;
	font-weight: 500;
}
</style>
